module.exports = __webpack_public_path__ + "static/cad-designs9-18aba8013b3f2b1b7743dbfb6f68f291.png";